import React, { useState } from 'react';
import InfoIcon from './InfoIcon';

export default function BottomCard({ item, quantity, price, showProductsOneRow, currencyStore, productTitle, onAdd, onRemove, onBlur, currAmount,onQuantityChange,isBorder = false }) {
  const [showDesc, setShowDesc] = useState(false);
  const displayPrice = quantity > 0 ? price * quantity : price;
  return (
    <div
      className={`bg-white rounded-lg flex flex-col items-start p-1 md:p-2 mb-2 min-h-0 ${
        isBorder ? 'border border-[#00A3DA]' : 'border-none'
      }`}
      tabIndex={0}
    >
      {/* Main card content */}
      <div className="w-full flex flex-col min-h-0">
        <div className="flex items-center w-full justify-center">
          <img
            src={item.image_link}
            alt={item.name}
            className={`${showProductsOneRow ? '' : 'hidden-'} md:block w-16 h-16 object-cover mr-2 rounded shadow-md`}
          />

          <div className="w-full flex flex-col">
            <div className="flex items-center w-full justify-between">
              <h3 className="font-brandingBold text-[#00A3DA] text-left">{item.name}</h3>
              <button
                type="button"
                onClick={e => {
                  e.stopPropagation();
                  setShowDesc(open => !open);
                }}
                className="ml-2 focus:outline-none"
              >
                <InfoIcon className="w-5 h-5 cursor-pointer" />
              </button>
            </div>

            {/* price + qty controls */}
            <div className={`flex items-center justify-between w-full ${'mt-2 md:mt-4'}`}>
              {/* price */}
              <div className="flex items-center bg-[#E9F7FF] rounded px-2 py-1">
                <span className="font-brandingBold text-[#00A3DA] text-[17px] px-2 py-1 leading-[12px] text-center">
                  {currAmount(currencyStore, displayPrice)}
                </span>
              </div>

              {/* "– qty +" */}
              <div className="flex items-center bg-[#E9F7FF] p-1 rounded min-w-[107px] justify-between">
                <button
                  className="bg-[#01A7E1] text-white text-2xl font-bold py-1.5 px-1.5 rounded leading-3"
                  onClick={e => {
                    e.stopPropagation();
                    onRemove();
                  }}
                  disabled={quantity === 0}
                >
                  –
                </button>
                <input
                  type="number"
                  min={0}
                  value={quantity}
                  onClick={e => e.stopPropagation()}
                  onChange={e => {
                    const val = parseInt(e.target.value, 10) || 0;
                    onQuantityChange(item, Math.max(0, val));
                  }}
                  className="w-12 bg-transparent text-center focus:outline-none text-[#00A3DA] font-bold"
                />
                <button
                  className="bg-[#01A7E1] text-white text-2xl font-bold py-1.5 px-1.5 rounded leading-3"
                  onClick={e => {
                    e.stopPropagation();
                    onAdd();
                  }}
                >
                  <img src="https://cdn.builder.io/api/v1/image/assets%2F32b8c354d4bc455dbf10fed3923dfae1%2Ffbf397a88f3f44a3956db6b7db7e1ed9" alt="+" className="w-3 h-3" />
                </button>
              </div>

              {/* Add button */}
              <button
                className="bg-pink text-white ml-3 px-2 py-1 rounded-lg min-w-[64px]"
                onClick={e => {
                  e.stopPropagation();
                  onAdd();
                }}
              >
                Add
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Expandable description */}
      {showDesc && (
        <div className="w-full mt-2 text-xs p-2 text-[#00A3DA] font-branding border-t border-gray-100">
          {item.short_description || item.description}
        </div>
      )}
    </div>
  );
}
